import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectCreatePermissionsResource } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/index.tsx';
import { polarisOnboardingRoute } from '@atlassian/jira-router-routes-polaris-routes/src/polarisOnboardingRoute.tsx';
import OnboardingPage, { LazyOnboardingPage } from './ui/onboarding/index.tsx';

export const polarisOnboardingRouteEntry = createEntry(polarisOnboardingRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	component: OnboardingPage,
	layout: globalLayout,
	canTransitionIn: () => true,
	resources: [...getNavigationResources(), projectCreatePermissionsResource],
	forPaint: [LazyAtlassianNavigation, LazyOnboardingPage],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-polaris-entries/src/polarisOnboardingRouteEntry.tsx',
			whichExportToUse: 'polarisOnboardingRouteEntry',
		},

		enabled: true,
	},
}));
